type Listener = () => void;

const listeners: Listener[] = [];

export const onPatientMessagesRead = (listener: Listener): (() => void) => {
  listeners.push(listener);

  return () => {
    const listenerIndex = listeners.indexOf(listener);
    if (listenerIndex !== -1) listeners.splice(listenerIndex, 1);
  };
};

export const emitPatientMessagesRead = (): void => {
  listeners.forEach((listener) => listener());
};
